/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import compose from "ramda/es/compose";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";

/**
 * The internal dependencies.
 */
import Footer from '../../components/footer';
import HomeNavigation from '../../components/home/navigation';
import HomeLogo from '../../components/home/logo';

import {getworkstepcount, resetOverlay} from "../../store/tasks/actions";
import {displayshop, getAuthUser, isDispo, isQuality} from "../../store/auth/selectors";
import {dispoGetDepartments, dispoGetUser} from "../../store/dispo/actions";

const HomeWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

const FooterWrapper = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
`;

class Home extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

        const {isQuality, getworkstepcount, isDispo, dispoGetUser, dispoGetDepartments, displayshop} = this.props;

        if (isDispo){
            this.props.history.push('/dashboard/disponent');
        } else if (isQuality){
            this.props.history.push('/dashboard/quality');
        } else {
            this.props.history.push('/dashboard/stock');
        }
    }

    render() {
        return (
            <HomeWrapper>
                <HomeLogo/>

                <FooterWrapper>
                    <HomeNavigation/>

                    <Footer style={{position: 'relative', marginTop: '16px'}}/>
                </FooterWrapper>
            </HomeWrapper>
        );
    }
}

export default compose(connect(
    (state) => (
        {
            user: getAuthUser(state),
            isQuality: isQuality(state),
            isDispo: isDispo(state),
            displayshop: displayshop(state)
        }),
    {
        resetOverlay,
        getworkstepcount,
        dispoGetDepartments,
        dispoGetUser,
    }), withRouter)(Home);



// WEBPACK FOOTER //
// ./src/pages/home/index.js